// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';
import { SpliceProvider } from '../utils/LedgerApiClientV2';

export type DAppSdkClientState = {
  client: SpliceProvider;
  setClient: (client: SpliceProvider) => void;
  resetClient: () => void;
};

const ERROR_MESSAGE =
  'DAppSdkClient not initialized. This is the default implementation for the client. You are probably seeing this because you forgot to wrap your component tree with DAppSdkClientProvider or are trying to use the client without initializing it';

export const defaultDAppSdkClientState: DAppSdkClientState = {
  client: {
    request: async () => {
      return Promise.reject(new Error(ERROR_MESSAGE));
    },
  },
  setClient: () => {
    console.error(ERROR_MESSAGE);
  },
  resetClient: () => {
    console.error(ERROR_MESSAGE);
  },
};

export const DAppSdkClientContext =
  React.createContext<DAppSdkClientState>(defaultDAppSdkClientState);

export const useDAppSdkClient = () => {
  const clientState = useContext(DAppSdkClientContext);
  return clientState.client;
};

export const useDAppSdkClientSetter = () => {
  const clientState = useContext(DAppSdkClientContext);
  return clientState.setClient;
};

export const useDAppSdkClientResetter = () => {
  const clientState = useContext(DAppSdkClientContext);
  return clientState.resetClient;
};
